import React from 'react';
import {Row, Col, TimePicker} from 'antd';
import IconFont from 'Components/common/iconFont';
import moment from 'moment';

const format = 'HH:mm';

const TimeSettingItem = ({
  time: {from = '06:00', to = '23:00'},
  index,
  groupIndex,
  changeTime,
  addTime,
  delTime,
}) => (
  <Row style={{marginBottom: 10}}>
    <Col span={10}>
      <TimePicker
        value={from ? moment(from, format) : null}
        format={format}
        allowEmpty={false}
        onChange={e =>
          changeTime({
            groupIndex,
            index,
            type: 'from',
            value: (e && e.format(format)) || '',
          })
        }
      />
    </Col>
    <Col span={2} style={{textAlign: 'center'}}>
      <span>~</span>
    </Col>
    <Col span={10}>
      <TimePicker
        value={to ? moment(to, format) : null}
        format={format}
        allowEmpty={false}
        onChange={e =>
          changeTime({
            groupIndex,
            index,
            type: 'to',
            value: (e && e.format(format)) || '',
          })
        }
      />
    </Col>
    <Col span={2} className="iconFont" style={{textAlign: 'right'}}>
      {index ? (
        <IconFont
          type="icon-robotminus-fill"
          style={{color: '#f04134'}}
          onClick={() =>
            delTime({
              groupIndex,
              index,
            })
          }
        />
      ) : (
        <IconFont
          type="icon-robotadd-fill"
          style={{color: '#34cb82'}}
          onClick={() => addTime(groupIndex)}
        />
      )}
    </Col>
  </Row>
);

export default TimeSettingItem;
